import withQuillLayout from 'src/_common/hoc/QuillLayout';
import Premium from 'src/payments';
import { DocumentContext } from 'next/document';

export default withQuillLayout({
  children: Premium,
});

export async function getServerSideProps({ res, query }: DocumentContext) {
  if (query.token && res) {
    res?.writeHead(302, {
      Location: `upgrade?token=${query.token}&ba_token=${query.ba_token}`,
    });
    res.end();
  }
  return { props: {} };
}
